import { apiSlice } from '../../app/api/apiSlice';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (payload) => {
        const params = new URLSearchParams();
        if (payload.page) params.append('page', payload.page);
        if (payload.limit) params.append('limit', payload.limit);
        if (payload.search) params.append('search', payload.search);

        return {
          url: `admin/users?${params.toString()}`,
          method: 'POST',
          body: { email: payload.email },
        };
      },
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    getUser: builder.query({
      query: (payload) => ({
        url: 'admin/user',
        method: 'POST',
        body: { ...payload },
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    addUser: builder.mutation({
      query: (payload) => ({
        url: 'admin/register',
        method: 'POST',
        body: { ...payload },
      }),
    }),
    updateUser: builder.mutation({
      query: (payload) => ({
        url: `admin/user`,
        method: 'PUT',
        body: { ...payload },
      }),
    }),
    deleteUser: builder.mutation({
      query: (payload) => ({
        url: `admin/user`,
        method: 'DELETE',
        body: { ...payload },
      }),
    }),
    addUserNote: builder.mutation({
      query: (payload) => ({
        url: 'user-note',
        method: 'POST',
        body: { ...payload },
      }),
    }),
    markUserNoteComplete: builder.mutation({
      query: (id) => ({
        url: `user-note/mark-as-complete/${id}`,
        method: 'POST',
      }),
    }),
    editUserNote: builder.mutation({
      query: ({ id, note }) => ({
        url: `user-note/edit/${id}`,
        method: 'PUT',
        body: { note },
      }),
    }),
    getUserSubscriptions: builder.query({
      query: (userId) => ({
        url: `admin/user/${userId}/subscriptions`,
      }),
      validateStatus: (response, result) => response.status === 200 && !result.isError,
    }),
    cancelUserSubscription: builder.mutation({
      query: ({ userId, userSubscriptionId, reason, note }) => ({
        url: `admin/user/${userId}/cancel-subscription`,
        method: 'POST',
        body: { userSubscriptionId, reason, note },
      }),
    }),
    pauseUserSubscription: builder.mutation({
      query: ({ userId, userSubscriptionId, mode, resumeDate, note }) => ({
        url: `admin/user/${userId}/pause-subscription`,
        method: 'POST',
        body: { userSubscriptionId, mode, resumeDate, note },
      }),
    }),
    resumeUserSubscription: builder.mutation({
      query: ({ userId, userSubscriptionId, mode, resumeDate, note }) => ({
        url: `admin/user/${userId}/resume-subscription`,
        method: 'POST',
        body: { userSubscriptionId, mode, resumeDate, note },
      }),
    }),
    getPlanChangeOptions: builder.query({
      query: ({ userId, userSubscriptionId }) => ({
        url: `customer/subscription/plan-change-options?userSubscriptionId=${userSubscriptionId}&userId=${userId}`,
      }),
      validateStatus: (response, result) => response.status === 200 && !result?.isError,
    }),
    changePlan: builder.mutation({
      query: ({ userId, userSubscriptionId, targetSubId, note }) => ({
        url: 'customer/subscription/change-plan',
        method: 'POST',
        body: { userSubscriptionId, targetSubId, userId, note },
      }),
    }),

    getCustomers: builder.query({
      query: ({ email, page = 1, limit = 20000, search = '' } = {}) => ({
        url: `admin/users?page=${page}&limit=${limit}&search=${search}`,
        method: 'POST',
        body: { email },
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    activeCustomer: builder.mutation({
      query: (payload) => ({
        url: `customer/active`,
        method: 'PUT',
        body: { ...payload },
      }),
    }),
    getInquiry: builder.query({
      query: (payload) => ({
        url: 'inquirybyid',
        method: 'POST',
        body: { ...payload },
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    getInquiries: builder.query({
      query: (payload) => ({
        url: 'inquiry/list',
        method: 'POST',
        body: { ...payload },
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
  }),
});

export const {
  useGetUserQuery,
  useGetUsersQuery,
  useAddUserMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useAddUserNoteMutation,
  useMarkUserNoteCompleteMutation,
  useEditUserNoteMutation,
  useGetUserSubscriptionsQuery,
  useCancelUserSubscriptionMutation,
  usePauseUserSubscriptionMutation,
  useResumeUserSubscriptionMutation,
  useGetPlanChangeOptionsQuery,
  useChangePlanMutation,

  useGetCustomersQuery,
  useActiveCustomerMutation,
  useGetInquiryQuery,
  useGetInquiriesQuery,
} = userApiSlice;
